var render = function render(){var _vm=this,_c=_vm._self._c;return _c('codemirror',{attrs:{"options":{
  ..._vm.cmOptions,
  theme: _vm.theme,
  mode: _vm.file.mode,
},"value":_vm.file.content},on:{"input":_vm.updateCode,"cursorActivity":_vm.updateEditorInfo}})
}
var staticRenderFns = []

export { render, staticRenderFns }